import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { LinkListItemComponent } from '../../../shared-extra/components/link-list-item/link-list-item.component';
import { StoryblokImage, StoryblokLink } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-large-link-list',
  standalone: true,
  templateUrl: './large-link-list.component.html',
  styleUrls: ['./large-link-list.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, LinkListItemComponent, StoryblokDirective],
})
export class LargeLinkListComponent {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() links: { link: StoryblokLink; image: StoryblokImage; title: string; subTitle: string; _editable: string }[];

  private storyblokService = inject(StoryblokService);

  isInternalLink(link: { link: StoryblokLink }) {
    if (link.link.linktype === 'story') return true;
    return link.link.url?.startsWith('/');
  }

  calcHref(link: { link: StoryblokLink }) {
    return this.storyblokService.getUrlLink(link.link);
  }
}
